module.exports = function(hljs) {
    return {
        disableAutodetect: true
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/highlight.js/lib/languages/plaintext.js
// module id = 317
// module chunks = 0